/**
 * useJourney - Manages journey planning state for DriverApp
 */
import { useState } from 'react';

export function useJourney() {
  const [journeyDestination, setJourneyDestination] = useState('');
  const [journeyLoading, setJourneyLoading] = useState(false);
  const [journeyResult, setJourneyResult] = useState(null);
  const [addressSuggestions, setAddressSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);

  return {
    journeyDestination, setJourneyDestination,
    journeyLoading, setJourneyLoading,
    journeyResult, setJourneyResult,
    addressSuggestions, setAddressSuggestions,
    showSuggestions, setShowSuggestions,
  };
}
